/**
 * Personalization Service
 * Manages the user's adaptive memory profile and personalization settings.
 */

import api from '@services/api';

export interface PersonalizationProfile {
  profile: string | null;
  enabled: boolean;
  has_pending?: boolean;
  self_role?: string;
  self_details?: string;
}

class PersonalizationService {
  async getProfile(): Promise<PersonalizationProfile> {
    const response = await api.get('/conversations/personalization/profile');
    return response.data;
  }

  async updateProfile(profile: string): Promise<void> {
    await api.put('/conversations/personalization/profile', { profile });
  }

  async clearProfile(): Promise<void> {
    await api.delete('/conversations/personalization/profile');
  }

  async updateSettings(enabled: boolean): Promise<void> {
    await api.put('/conversations/personalization/settings', { enabled });
  }

  async updateSelfContext(role: string, details: string): Promise<void> {
    await api.put('/conversations/personalization/self-context', { role, details });
  }
}

export const personalizationService = new PersonalizationService();
